import React, { PropsWithChildren } from "react";

import { type AutocompleteOption } from "@src/sharedComponents/Dropdown/Dropdown";
import FormDropdownField from "@src/sharedComponents/Forms/FormDropdownField";

interface Props {
  fieldName: string;
  fieldLabel: string;
  curOption: string;
  options: AutocompleteOption[];
  displayInput1OnOptions: { label: string; value: string }[];
  additionalInput1: React.ReactNode;
  startOnNewLineInput1?: boolean;
  fillUpSpaceIfNotRenderedInput1?: boolean;
  displayInput2OnOptions?: { label: string; value: string }[];
  additionalInput2?: React.ReactNode;
  startOnNewLineInput2?: boolean;
  fillUpSpaceIfNotRenderedInput2?: boolean;
  displayInput3OnOptions?: { label: string; value: string }[];
  additionalInput3?: React.ReactNode;
  startOnNewLineInput3?: boolean;
  fillUpSpaceIfNotRenderedInput3?: boolean;
  isDisabled?: boolean;
  isHidden?: boolean;
  readOnly?: boolean;
  fillUpSpaceIfNoInputsRendered?: boolean;
}

const MultiDropdownInput = ({
  fieldName,
  fieldLabel,
  curOption,
  options,
  displayInput1OnOptions,
  additionalInput1,
  fillUpSpaceIfNotRenderedInput1 = false,
  displayInput2OnOptions,
  additionalInput2,
  fillUpSpaceIfNotRenderedInput2 = false,
  displayInput3OnOptions,
  additionalInput3,
  fillUpSpaceIfNotRenderedInput3 = false,
  isDisabled = false,
  isHidden = false,
  readOnly = false,
  fillUpSpaceIfNoInputsRendered = false,
  children, // If the FormDropdownField is starting in the 2nd position (to the right of another input field) -> pass in the first input field as a child (one on the left)
}: PropsWithChildren<Props>) => {
  const displayInput1 = displayInput1OnOptions.some(
    (o) => o.value === curOption
  );

  const displayInput2 = (displayInput2OnOptions ?? []).some(
    (o) => o.value === curOption
  );

  const displayInput3 = (displayInput3OnOptions ?? []).some(
    (o) => o.value === curOption
  );
  return (
    <>
      {children}

      {!isHidden && (
        <FormDropdownField
          name={fieldName}
          label={fieldLabel}
          values={options}
          disableSearch={true}
          disabled={isDisabled}
          readonly={readOnly}
        />
      )}

      {children && isHidden && !displayInput1 && <div />}

      {displayInput1
        ? additionalInput1
        : fillUpSpaceIfNotRenderedInput1 && !children && !isHidden && <div />}

      {displayInput2
        ? additionalInput2
        : fillUpSpaceIfNotRenderedInput2 && <div />}

      {displayInput3
        ? additionalInput3
        : fillUpSpaceIfNotRenderedInput3 && <div />}

      {!displayInput1 &&
        !displayInput2 &&
        !displayInput3 &&
        fillUpSpaceIfNoInputsRendered && <div />}
    </>
  );
};

export default MultiDropdownInput;
